import React, { ReactElement, FunctionComponent } from "react";
import { Route, Router, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import history from "../config/history";
import routes from "./routes";

type RouteProps = {
  path: string;
  strict: boolean;
  exact: boolean;
  component: FunctionComponent<null>;
};

const renderRoute = (route: RouteProps) => (
  <Route
    key={route.path}
    path={route.path}
    strict={route.strict}
    exact={route.exact}
    component={route.component}
  />
);

export default (): ReactElement => (
  <ConnectedRouter history={history}>
    <Router history={history}>
      <Switch>
        {routes.map((route) => renderRoute(route))}
        <Route path="/*" />
      </Switch>
    </Router>
  </ConnectedRouter>
);
